<template>
    <v-container fluid class="main-container d-block pa-0">
        <DeviceHeaderMenu v-if="roomData.uid" :roomData="roomData" :edit="edit" @setEdit="setEdit" @back="back"/>
        <v-layout column class="controllers-list ma-0" v-if="edit">
            <v-flex class="controllers-list__edit main-text" xs12 v-for="(controller, index) in controllers" :key="index">
                <v-text-field
                    v-model="controller.name"
                    placeholder="Введите серийный номер"
                    class="grey-input d-inline-flex ma-0"
                    dense
                    hide-details
                    @keyup.enter="setController(controller)"
                    :readonly="!!controller.uid"
                ></v-text-field>
                :
                <div v-if="controller.uid">
                    <span class="green-text ml-1" v-if="controller.online">online</span>
                    <span class="red-text ml-1" v-else>offline</span>
                </div>
                <div v-if="controller.uid" class="close-btn" @click="openJoinDevice(controller)">
                    <v-img :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex ml-2"/>
                </div>
                <div class="close-btn" @click="openModalDeleteController(controller)">
                    <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex ml-1"/>
                </div>
            </v-flex>
            <v-flex class="controllers-list__edit main-text" xs12>
                <v-btn class="btn-light-grey btn-controllers main-text" @click="addController">
                    Добавить контроллер +
                </v-btn>
            </v-flex>
        </v-layout>
        <div v-if="!edit && controllers.length" class="controllers-list">
            <v-flex
                class="controllers-list__row main-text d-flex align-center"
                xs12
                v-for="(controller, index) in controllers"
                :key="index"
            >
                {{controller.name}}:
                <span class="green-text ml-1" v-if="controller.online">online</span>
                <span class="red-text ml-1" v-else>offline</span>
                <v-tooltip top content-class="arrow-down" v-model="show" v-if="!controller.online">
                    <template v-slot:activator="{ on, attrs }">
                        <div class="d-inline-flex disabled-icon" v-bind="attrs" v-on="on" @click="show = true">
                            <v-img :src="require('@/assets/icons/reboot_icon.svg')" class="d-inline-flex ml-2"/>
                        </div>
                    </template>
                    <div class="main-text">
                        Контроллер не в сети
                    </div>
                </v-tooltip>
                <div
                    class="d-inline-flex"
                    @click="openModalRebootController(controller)"
                    v-else-if="!controller.loadingReboot"
                >
                    <v-img :src="require('@/assets/icons/reboot_icon.svg')" class="d-inline-flex ml-2"/>
                </div>
                <v-progress-circular
                    class="ml-2"
                    size="18"
                    width="2"
                    color="rgba(255, 132, 132, 0.54)"
                    indeterminate
                    v-if="controller.loadingReboot"
                />
            </v-flex>
        </div>
        <div class="px-8 py-4">
            <v-tabs fixed-tabs grow v-model="tabSelected" class="tabs-title" v-if="devices.length > 0 || scenarios.length > 0">
                <v-tab key="devices" href="#devices" class="left-tab">
                    Устройства <span v-if="devices.length > 0" class="ml-1">({{devices.length}})</span>
                </v-tab>
                <v-tab key="scenarios" href="#scenarios" class="right-tab">
                    Сценарии <span v-if="scenarios.length > 0" class="ml-1">({{scenarios.length}})</span>
                </v-tab>
            </v-tabs>
        </div>
        <v-tabs-items v-model="tabSelected" class="tabs-container">
            <v-tab-item key="devices" value="devices">
                <Slider v-model="activeGroup" :list="locations" :show-info-icon="hasOffline"></Slider>
                <v-layout class="devices-list" v-if="devicesFiltered.length > 0 || (edit && controllers.length)" row>
                    <v-flex
                        class="devices-list__device"
                        :class="{'devices-list__device__large': largeScreen}"
                        :xs4="!largeScreen"
                        :xs3="largeScreen"
                        v-for="(deviceColumn, indexColumn) in devicesFiltered"
                        :key="`deviceColumn${indexColumn}`"
                    >
                        <v-layout column>
                            <v-flex v-for="(device, index) in deviceColumn" :key="`device${index}`">
                                <CardholderDevice v-if="device.device_type == 1" :device="device" :edit="edit" :showLocation="showLocation"/>
                                <SwitchDevice v-if="device.device_type == 2" :device="device" :edit="edit" :showLocation="showLocation"/>
                                <VentilationDevice v-if="device.device_type == 5" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <LightingDevice v-if="device.device_type == 9" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <WaterShutOffDevice v-if="device.device_type == 14" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <SocketDevice v-if="device.device_type == 10" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <FridgeDevice v-if="device.device_type == 11" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <MotionSensorDevice v-if="device.device_type == 3" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <OpeningSensorDevice v-if="device.device_type == 4" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <LeakSensorDevice v-if="device.device_type == 6" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <ThermometerDevice v-if="device.device_type == 7" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <CurtainsDevice v-if="device.device_type == 8" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <HeatingDevice v-if="device.device_type == 12" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <WarmFloorDevice v-if="device.device_type == 13" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <DimmableLightingDevice v-if="device.device_type == 15" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <TVDevice v-if="device.device_type == 16" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <IlluminationSensor v-if="device.device_type == 17" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                                <HumidityDevice v-if="device.device_type == 18" :device="device" :edit="edit" :free="true" :showLocation="showLocation"/>
                            </v-flex>
<!--                            <v-flex-->
<!--                                :xs4="!largeScreen"-->
<!--                                :xs3="largeScreen"-->
<!--                                class="add-device"-->
<!--                                v-if="edit && indexColumn === editColumn"-->
<!--                            >-->
<!--                                <v-btn class="btn-light-grey" @click="openModalAddDevice">-->
<!--                                    <PlusIcon></PlusIcon>-->
<!--                                    <div class="mt-3">Добавить устройство</div>-->
<!--                                </v-btn>-->
<!--                            </v-flex>-->
                        </v-layout>
                    </v-flex>
                    <v-btn class="btn-light-grey" v-if="showButton && !openedList" @click="openedList = true">
                        Показать всё
                    </v-btn>
                </v-layout>
                <div class="d-flex align-center" v-else>
                    <v-flex class="d-block text-center">
                        <div>
                            <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                            <div class="common-text text-center">
                                Нет добавленных устройств
                            </div>
                        </div>
                    </v-flex>
                </div>
                <v-layout v-if="loadingDevices" class="align-center justify-center" column>
                    <div class="main-text mb-1"> Загрузка... </div>
                    <v-flex class="d-inline-flex justify-center">
                        <v-img class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item key="scenarios" value="scenarios">
                <Slider v-model="activeGroupScenario" :list="locationsScenario"></Slider>
                <v-layout
                    ref="deviceOverflow"
                    class="devices-list"
                    v-if="scenarioList.length > 0 || (edit && controllers.length)"
                    :key="activeGroupScenario"
                    row
                >
                    <v-flex
                        class="devices-list__device"
                        :class="{'devices-list__device__large': largeScreen}"
                        :xs4="!largeScreen"
                        :xs3="largeScreen"
                        v-for="(scenarioColumn, indexColumn) in scenarioList"
                        :key="`scenarioColumn${indexColumn}`"
                    >
                        <v-layout column>
                            <v-flex v-for="(scenario, index) in scenarioColumn" :key="`scenario${index}`">
                                <ScenarioGroup
                                    v-if="scenario.group"
                                    :group="scenario"
                                    :showLocation="activeGroupScenario === 0"
                                    :available="available"
                                    :edit="edit"
                                ></ScenarioGroup>
                                <ScenarioSwitch
                                    v-else
                                    :scenario="scenario"
                                    :edit="edit"
                                    :showLocation="activeGroupScenario === 0"
                                    :room="room"
                                    :available="available"
                                ></ScenarioSwitch>
                            </v-flex>
                            <v-flex
                                :xs4="!largeScreen"
                                :xs3="largeScreen"
                                class="add-device"
                                v-if="edit && indexColumn === editScenarioColumn"
                            >
                                <v-btn class="btn-light-grey" @click="openModalAddScenario">
                                    <PlusIcon></PlusIcon>
                                    <div class="mt-3">Добавить сценарий</div>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout v-if="loadingScenarios" class="align-center justify-center" column>
                    <div class="main-text mb-1"> Загрузка... </div>
                    <v-flex class="d-inline-flex justify-center">
                        <v-img class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
                    </v-flex>
                </v-layout>
            </v-tab-item>
        </v-tabs-items>
        <ModalRebootController
            v-model="modalRebootController"
            :controller="choosenController"
            :close="closeModalRebootController"
            :reboot="rebootController"
        ></ModalRebootController>
        <ModalDeleteConfirm
            v-model="modalDeleteController"
            :close="closeModalDeleteController"
            :url="`/devices/admin/management-controller/${room}/?controller=${choosenController.uid}`"
        >
            <template #deleteTitle>
                Вы действительно хотите удалить <br> контроллер?
            </template>
            <template #deleteSubtitle>
                После удаления контроллера<br>
                <span class="common-text">{{choosenController.name}}</span><br>
                вы потеряете доступ к некоторым устройствам
            </template>
        </ModalDeleteConfirm>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
    </v-container>
</template>

<script>
import DeviceHeaderMenu from "@/components/DeviceHeaderMenu";
import deviceTypes from "../plugins/deviceTypes.js";
import CardholderDevice from "@/components/devices/CardholderDevice";
import VentilationDevice from "@/components/devices/VentilationDevice";
import ThermometerDevice from "@/components/devices/ThermometerDevice";
import SwitchDevice from "@/components/devices/SwitchDevice";
import MotionSensorDevice from "@/components/devices/MotionSensorDevice";
import OpeningSensorDevice from "@/components/devices/OpeningSensorDevice";
import LeakSensorDevice from "@/components/devices/LeakSensorDevice";
import CurtainsDevice from "@/components/devices/CurtainsDevice";
import LightingDevice from "@/components/devices/LightingDevice";
import SocketDevice from "@/components/devices/SocketDevice";
import FridgeDevice from "@/components/devices/FridgeDevice";
import HeatingDevice from "@/components/devices/HeatingDevice";
import WarmFloorDevice from "@/components/devices/WarmFloorDevice";
import WaterShutOffDevice from "@/components/devices/WaterShutOffDevice";
import DimmableLightingDevice from "@/components/devices/DimmableLightingDevice";
import TVDevice from "@/components/devices/TVDevice";
import IlluminationSensor from "@/components/devices/IlluminationSensor";
import HumidityDevice from "@/components/devices/HumidityDevice";
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";
import ModalRebootController from "@/components/modals/ModalRebootController";
import PlusIcon from "@/assets/icons/PlusIcon";
import ModalWaiting from "@/components/modals/ModalWaiting";
import ScenarioSwitch from "@/components/rooms/ScenarioSwitch";
import ScenarioGroup from "@/components/rooms/ScenarioGroup";
import Slider from "@/components/Slider.vue";
import Centrifuge from "centrifuge";
import {eventBus} from "@/main";
import {mapMutations} from "vuex";

export default {
    name: "RoomPage",
    components: {
        DeviceHeaderMenu,
        CardholderDevice,
        VentilationDevice,
        ThermometerDevice,
        SwitchDevice,
        MotionSensorDevice,
        OpeningSensorDevice,
        LeakSensorDevice,
        CurtainsDevice,
        LightingDevice,
        SocketDevice,
        FridgeDevice,
        HeatingDevice,
        WarmFloorDevice,
        WaterShutOffDevice,
        DimmableLightingDevice,
        TVDevice,
        ModalDeleteConfirm,
        PlusIcon,
        ModalRebootController,
        ScenarioSwitch,
        ScenarioGroup,
        Slider,
        ModalWaiting,
        IlluminationSensor,
        HumidityDevice,
    },
    data() {
        return {
            room: null,
            controllers: [],
            devices: [],
            locations: [],
            locationsScenario: [],
            deviceTypes: deviceTypes,
            sorted: [1, 2, 5, 9, 14, 10, 11, 3, 4, 6, 7, 8, 15, 16, 12, 13, 17, 18],
            categories: ["Все"],
            activeGroup: 0,
            activeGroupScenario: 0,
            edit: false,
            modalDeleteController: false,
            modalRebootController: false,
            choosenController: {},
            centrifuge: null,
            roomData: {
                free: false,
            },
            show: false,
            openedList: false,
            windowWidth: window.innerWidth,
            scenarios: [],
            editColumn: 0,
            editScenarioColumn: 0,
            reconnect: false,
            groupsScenario: [],
            loadingDevices: false,
            loadingScenarios: false,
            available: [],
            tabSelected: "devices",
        };
    },
    created() {
        if (this.$route.query.tab || this.$route.params.tab) {
            this.tabSelected = this.$route.query.tab || this.$route.params.tab;
        }
        if (this.$route.query.edit || this.$route.params.edit) {
            this.edit = true;
        }
        if (this.$route.query.location) {
            this.activeGroupScenario = parseInt(this.$route.query.location);
        }
        eventBus.$on("reconnectRoom", this.loadPage);
        eventBus.$on("hotel", this.setChangeHotelList);
        eventBus.$on("device", this.updateDevice);
        eventBus.$on("controller", this.updateController);
        eventBus.$on("scenarioGroup", this.updateScenariosGroup);
    },
    mounted() {
        this.loadPage();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
        window.removeEventListener('resize', this.onResize);
        eventBus.$off("reconnectRoom", this.loadPage);
        eventBus.$off("hotel", this.setChangeHotelList);
        eventBus.$off("device", this.updateDevice);
        eventBus.$off("controller", this.updateController);
        eventBus.$off("scenarioGroup", this.updateScenariosGroup);
    },
    computed: {
        largeScreen() {
            return this.windowWidth > 1440;
        },
        showButton() {
            if (this.deviceGroup.length > 10 && !this.openedList) {
                return true;
            }
            return false;
        },
        deviceGroup() {
            if (this.hasOffline && this.activeGroup == 1) {
                return this.devices.filter((el) => { return !el.online });
            } else if (this.activeGroup > 0) {
                return this.devices.filter((el) => { return el.location == this.locations[this.activeGroup] });
            }
            return this.devices;
        },
        devicesFiltered() {
            let deviseList = this.showButton ? JSON.parse(JSON.stringify(this.deviceGroup)).splice(0, 10) : this.deviceGroup;
            deviseList = deviseList.sort((a, b) => (a.name > b.name) ? 1 : -1);
            let divider = this.largeScreen ? 4 : this.windowWidth > 1151 ? 3 : this.windowWidth > 701 ? 2 : 1;
            let minLength = parseInt(deviseList.length / divider);
            let deviceArr = [];
            let slice = 0;
            for (let i = 0; i < divider; i++) {
                if ((deviseList.length % divider) > i) {
                    deviceArr[i] = deviseList.slice(slice, slice + minLength + 1);
                    slice += minLength + 1;
                } else {
                    if ((deviseList.length % divider) === i) {
                        this.editColumn = i;
                    }
                    deviceArr[i] = deviseList.slice(slice, slice + minLength);
                    slice += minLength;
                }
            }
            return deviceArr;
        },
        scenarioGroup() {
            if (this.activeGroupScenario > 0) {
                return this.scenarios.filter((el) => { return el.location == this.locationsScenario[this.activeGroupScenario] });
            }
            return this.scenarios;
        },
        scenarioList() {
            let scenariosList = JSON.parse(JSON.stringify(this.scenarioGroup));
            let divider = this.largeScreen ? 4 : this.windowWidth > 1151 ? 3 : this.windowWidth > 701 ? 2 : 1;
            let minLength = parseInt(scenariosList.length / divider);
            let scenariosArr = [];
            let slice = 0;
            for (let i = 0; i < divider; i++) {
                if ((scenariosList.length % divider) > i) {
                    scenariosArr[i] = scenariosList.slice(slice, slice + minLength + 1);
                    slice += minLength + 1;
                } else {
                    if ((scenariosList.length % divider) === i) {
                        this.editScenarioColumn = i;
                    }
                    scenariosArr[i] = scenariosList.slice(slice, slice + minLength);
                    slice += minLength;
                }
            }
            return scenariosArr;
        },
        hasOffline() {
            return this.devices.some((el) => !el.online);
        },
        showLocation() {
            return this.hasOffline ? [0, 1].includes(this.activeGroup) : this.activeGroup == 0;
        },
    },
    methods: {
        ...mapMutations(['setTimezone']),
        loadPage() {
            this.$refs.modalWaiting.open();
            this.room = this.$route.params.id;
            if (this.room) {
                this.getRoom();
                this.getControllers();
                this.getDevices();
                this.getScenarios();
            }
        },
        getRoom() {
            this.roomData = {
                free: false,
            };
            this.$http.get('/hotels/hotel-admin/rooms/' + this.room + '/')
                .then((response) => {
                    this.roomData = response.data;
                    if (this.roomData && this.roomData.hotel) {
                        this.$store.commit("setTimezone", this.roomData.hotel.timezone);
                    }
                    this.openWebSocket();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (this.$refs.modalWaiting) {
                        this.$refs.modalWaiting.close();
                    }
                });
        },
        getControllers() {
            this.$http.get('/controllers/hotel-admin/management-controller/' + this.room + '/')
                .then((response) => {
                    this.controllers = response.data.results;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (this.$refs.modalWaiting) {
                        this.$refs.modalWaiting.close();
                    }
                });
        },
        getDevices() {
            this.loadingDevices = true;
            this.locations = [];
            this.devices = [];
            if (this.categories.length > 1) {
                this.categories.splice(1, 1);
            }
            this.$http.get('/devices/hotel-admin/device-list/' + this.room + '/')
                .then((response) => {
                    this.sorted.forEach(el => {
                        let matched = response.data.devices.filter(elem => {
                            return elem.device_type == el
                        });
                        this.devices = this.devices.concat(matched);
                    });
                    if (this.hasOffline) {
                        this.categories.push("Неисправные");
                    }
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    response.data.locations.forEach((el) => {
                        if (el) {
                            this.locations.push(el);
                        }
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (this.$refs.modalWaiting) {
                        this.$refs.modalWaiting.close();
                    }
                    this.loadingDevices = false;
                });
        },
        getScenarios() {
            this.loadingScenarios = true;
            this.scenarios = [];
            this.groupsScenario = [];
            this.locationsScenario = [];
            this.$http.get('/scenarios/hotel-admin/scenarios-list/' + this.room + '/')
                .then((response) => {
                    this.groupsScenario = response.data.groups;
                    this.groupsScenario.forEach((el) => {
                        el.group = true;
                    });
                    this.scenarios = this.groupsScenario.concat(response.data.scenarios);
                    this.locationsScenario = JSON.parse(JSON.stringify(this.categories));
                    response.data.locations.forEach((el) => {
                        if (el) {
                            this.locationsScenario.push(el);
                        }
                    });
                    if (this.activeGroupScenario > this.locationsScenario.length - 1) {
                        this.activeGroupScenario = 0;
                    }
                    this.available = response.data.available_conditions_and_actions;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (this.$refs.modalWaiting) {
                        this.$refs.modalWaiting.close();
                    }
                    this.loadingScenarios = false;
                });
        },
        setEdit(value) {
            this.edit = value;
        },
        addController() {
            this.controllers.push({name: null});
        },
        setController(item) {
            let indexItem = this.controllers.length - 1;
            this.$http.put('/controllers/hotel-admin/management-controller/' + this.room + '/', {
                controller_serial_number: item.name,
            })
                .then(() => {
                    this.controllers.splice(indexItem, 1);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        openModalDeleteController(item) {
            if (item.uid) {
                this.choosenController = item;
                this.modalDeleteController = true;
            } else {
                let controllerChanged = this.controllers.find((el) => { return el.name == item.name });
                let controllerIndex = this.controllers.indexOf(controllerChanged);
                this.controllers.splice(controllerIndex, 1);
            }
        },
        closeModalDeleteController() {
            this.modalDeleteController = false;
            this.choosenController = {};
        },
        openModalAddDevice() {
            this.$router.push({ name: "devicepage", params: { id: this.roomData.uid } });
        },
        openModalAddScenario() {
            this.$router.push({
                name: "scenariopage",
                params: { id: this.roomData.uid },
                query: { location: this.activeGroupScenario }
            });
        },
        openWebSocket() {
            this.centrifuge = new Centrifuge(process.env.VUE_APP_WS_API_URL, {
                retry: 1000,
                maxRetry: 2000,
            });
            this.centrifuge.time_create = Math.random();
            const user_access_token = this.$store.state.accessToken;
            const room_pk = this.roomData.uid;

            this.centrifuge.setConnectData({
                'user_access_token': user_access_token,
                'room_pk': room_pk,
            });
            let is_subscribe = false;

            this.centrifuge.on('connect', (ctx) => {
                console.log("connected", ctx);
                if (this.reconnect) {
                    this.reconnect = false;
                    eventBus.$emit("reconnectRoom");
                }
                let room_id = ctx.data.room_token;

                if (!is_subscribe) {
                    this.centrifuge.subscribe("room_update:room_" + room_id, function (ctx) {
                        if (ctx.data.update_type == "device") {
                            eventBus.$emit("device", {
                                is_delete: ctx.data.is_delete,
                                device: ctx.data.device,
                            });
                        } else if (ctx.data.update_type == "controller") {
                            eventBus.$emit("controller", {
                                is_delete: ctx.data.is_delete,
                                controller: ctx.data.controller,
                            });
                        } else if (ctx.data.notification_type == "scenario_group") {
                            eventBus.$emit("scenarioGroup", {
                                group: ctx.data.group
                            });
                        }
                    });
                    is_subscribe = true;
                }

                this.centrifuge.on('disconnect', (ctx) => {
                    this.reconnect = true;
                    console.log("disconnected", ctx);
                });
            });

            this.centrifuge.connect();
        },
        updateDevice(data) {
            let deviceChanged = this.devices.find((el) => { return el.uid == data.device.uid });
            let deviceIndex = this.devices.indexOf(deviceChanged);
            data.disabled = false;
            if (!data.is_delete) {
                let locationIndex = this.locations.indexOf(this.locations.find((el) => { return el == data.device.location }));
                if (locationIndex == -1) {
                    this.locations.push(data.device.location);
                }
                if (deviceIndex != -1) {
                    this.$set(this.devices, deviceIndex, data.device);
                } else {
                    this.devices.push(data.device);
                }
            } else {
                if (deviceIndex != -1) {
                    this.devices.splice(deviceIndex, 1);
                }
            }
        },
        updateController(data) {
            let controllerChanged = this.controllers.find((el) => { return el.uid == data.controller.uid });
            let controllerIndex = this.controllers.indexOf(controllerChanged);
            if (!data.is_delete) {
                if (controllerIndex != -1) {
                    this.$set(this.controllers, controllerIndex, data.controller);
                } else {
                    this.controllers.push(data.controller);
                }
            } else {
                if (controllerIndex != -1) {
                    this.controllers.splice(controllerIndex, 1);
                }
            }
        },
        openModalRebootController(item) {
            if (item.uid && item.online) {
                this.choosenController = item;
                this.modalRebootController = true;
            }
        },
        closeModalRebootController() {
            this.modalRebootController = false;
        },
        rebootController(force) {
            this.choosenController.loadingReboot = true;
            let url = `/controllers/hotel-admin/reboot-controller/${this.choosenController.uid}/`;
            this.closeModalRebootController();
            this.$http.put(url, {
                "force": force,
            })
                .then(() => {
                    this.choosenController.loadingReboot = false;
                    this.choosenController = null;
                })
                .catch((error) => {
                    console.log(error);
                    this.choosenController.loadingReboot = false;
                });
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        updateScenariosGroup(data) {
            let groupChanged = this.scenarios.filter((el) => { return el.uid == data.group.uid })[0];
            let groupIndex = this.scenarios.indexOf(groupChanged);
            this.data.group.group = true;
            this.$set(this.scenarios, groupIndex, data.group);
        },
        back() {
            this.$router.push({name: "hotelpage", query: {hotel: this.roomData ? this.roomData.hotel.uid : null}});
        },
        openJoinDevice(controller) {
            if (controller) {
                if (controller.model == 1) {
                    this.$router.push({ name: "debugcontrollerpage", params: { id: controller.uid } });
                } else if (controller.model == 2) {
                    this.$router.push({ name: "controllerpage", params: { id: controller.uid } });
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
}

.connection-animate {
    animation: scale 1s infinite linear;
    max-width: 42px;
    max-height: 42px;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>

<style lang="scss">
.add-device {
    min-height: 100%;
    display: inline-flex;
    margin-bottom: 8px;

    .btn-light-grey.v-btn {
        max-width: 100%;
        box-shadow: 0 2px 15px rgba(37, 37, 37, 0.1);
        height: 100%;
        border-radius: 30px;
        padding: 24px;

        .v-btn__content {
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
}

.title-group {
    max-width: 700px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: 600;
    font-size: 24px;
    line-height: 26px;
    color: #130F26;
    margin: 12px 24px 0 24px;
}
</style>